export function getRootCategories(categories) {
    const root_categories = []

    if (categories.length !== 0) {
        categories.forEach(category => {
            if (!category.parent_category_name) {
                root_categories.push(category)
            }
        })
    }

    return root_categories
}